import IconProps, { StyledPath } from './IconProps';

function TrashIcon(props: IconProps & { display?: string }) {
	const { color, display } = props;

	const style = display ? { display } : undefined;

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="13"
			height="16"
			viewBox="0 0 13 16"
			style={style}
		>
			<g fill={color} fillRule="evenodd" stroke="none" strokeWidth="1">
				<g transform="translate(-858 -1870)">
					<StyledPath
						color={color}
						fillRule="nonzero"
						d="M870 1875v10a1 1 0 01-1 1h-9a1 1 0 01-1-1v-10a1 1 0 01-1-1v-1a1 1 0 011-1h3v-1.5a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v1.5h3a1 1 0 011 1v1a1 1 0 01-1 1zm-10 .5v9a.5.5 0 00.5.5h8a.5.5 0 00.5-.5v-9.5h-9v.5zm6-4.5h-3v1h3v-1zm3.5 2h-10a.5.5 0 000 1h10a.5.5 0 100-1zm-6.5 11h-1v-7h1v7zm2 0h-1v-7h1v7zm2 0h-1v-7h1v7z"
					/>
				</g>
			</g>
		</svg>
	);
}

export default TrashIcon;
